import { Button, ButtonStyle } from '../../atoms/Button';
import { Checkbox } from '../../atoms/Checkbox';
import { PopupList } from '../../atoms/PopupList';
import React, { FC, PropsWithChildren, useEffect, useState } from 'react';

type FilterItem = {
  label: string;
  value: string;
};
export interface FilterListProps extends PropsWithChildren {
  /** the list of items to show in the popup */
  items: FilterItem[];
  /** a description of the popup for screen readers and other AT */
  filterDescription: string;
  handleFilter: (statusList: string[]) => void;
}
export const FilterList: FC<FilterListProps> = ({
  items,
  filterDescription,
  handleFilter,
}) => {
  const [filterItems, setFilterItems] = useState<string[]>([]);

  useEffect(() => {
    handleFilter(filterItems);
  }, [filterItems]);

  function handleFilterChange(filter: string) {
    if (filterItems.includes(filter)) {
      setFilterItems(filterItems.filter((item) => item !== filter));
    } else {
      setFilterItems([...filterItems, filter]);
    }
  }

  return (
    <div role="region">
      <PopupList
        items={
          <>
            {items.map((item, idx) => (
              <Checkbox
                key={idx}
                label={item.label}
                id={item.value}
                checked={filterItems.includes(item.value)}
                onChange={() => handleFilterChange(item.value)}
              />
            ))}
          </>
        }
        popupDescription={filterDescription}
      >
        <Button $buttonStyle={ButtonStyle.Secondary}>
          {filterDescription}
        </Button>
      </PopupList>
    </div>
  );
};
